import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from 'components/Button';
import Typography from 'components/Typography';

import { useAuth } from 'hooks/useAuth';
import { FeatureFlag, useFeatureFlags } from 'hooks/useFeatureFlags';
import useSubscriptionPlans from 'hooks/useSubscriptionPlans';

import { useUrls } from 'constants/urls';

const BuySubscriptionCta = () => {
  const { hasPremiumAccess } = useAuth();
  const { isFeatureFlagEnabled } = useFeatureFlags();
  const { maxTrialDuration } = useSubscriptionPlans();
  const { pricingPage } = useUrls();

  if (hasPremiumAccess) {
    return null;
  }

  const title =
    maxTrialDuration > 0
      ? {
          id: 'components.ExplorePageBuyButtonCta.buttonText',
          values: { days: maxTrialDuration },
        }
      : {
          id: 'common.button.cta',
        };

  return (
    <div className="BuySubscriptionCta bottom-0 flex flex-col h-[72px] justify-center sticky w-full">
      {isFeatureFlagEnabled(FeatureFlag.UNLOCK_ALL_AUDIOS) && (
        <div className="ExplorePageBuyButtonCta__message p-4">
          <Typography variant="body">
            <strong>
              <FormattedMessage id="features.unlockAllAudios.cta" />
            </strong>
          </Typography>
        </div>
      )}
      <div className="BuySubscriptionCta__buttonWrapper mx-6">
        <Button title={title} linkTo={pricingPage} />
      </div>
    </div>
  );
};

export default BuySubscriptionCta;
